import 'babel-polyfill';
import 'nodelist-foreach-polyfill';
import smoothscroll from 'smoothscroll-polyfill';
import ReactOnRails from 'react-on-rails';
import StyleGuide from '../bundles/EventSubmission/components/StyleGuide';
import CancelPackageButton from '../bundles/PageSpecificComponents/CancelPackageButton';
import InvoiceMenuButton from '../bundles/PageSpecificComponents/InvoiceMenuButton';
import ImageSlider from '../bundles/EmailCampaign/ImageSlider.js';
import AudienceSelect from '../bundles/EmailCampaign/audienceSelector.js'
import AudienceChecker from '../bundles/EmailCampaign/audienceChecker.js'
import EmailPreview from '../bundles/EmailCampaign/emailPreview.js'
import Rails from 'rails-ujs';
import Honeybadger from 'honeybadger-js';
import Cookies from 'js-cookie';
import {
  getCookieHost
} from 'lib/support';

Honeybadger.configure({
  apiKey: HONEYBADGER_KEY,
  environment: NODE_ENV,
  disabled: NODE_ENV === 'development'
});

Cookies.defaults.domain = getCookieHost();

Rails.start();
smoothscroll.polyfill();

ReactOnRails.register({
  CancelPackageButton,
  InvoiceMenuButton,
  StyleGuide,
  ImageSlider
});



// WEBPACK FOOTER //
// app/client/packs/base.js